import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import RegistrationForm from '../../components/registrationForm/registrationForm';
import BackButton from '../../components/backButton/backButton';

import './register.less';

export default () => (
  <Container className="register-page page-container">
    <BackButton to="/" />
    <div className="title-wrapper">
      <Typography variant="h3">
        Rejestracja
      </Typography>
    </div>
    <Paper className="paper-box">
      <Container>
        <RegistrationForm />
      </Container>
    </Paper>
  </Container>
);
